export default (function () {
    const seoBlock = {
        seoBlock() {
            $('.js--show_more_text').click(() => {
                $('#cmsinfo_block_text').collapse('show');
                $('.js--show_more_text').addClass('hide');
            });
        },
    };
    $(document).ready(() => {
        seoBlock.seoBlock();
    });
}());
